    var swiper;
    
    var handleSwiper = function() {
      if (window.innerWidth <= 1050) {
    if (!swiper) {
      swiper = new Swiper(".mySwiper", {
        slidesPerView: 2,
        spaceBetween: 0,
        speed: 600,
        grabCursor: true,
        snapOnRelease: true,
        freeMode: true, 
        freeModeMomentum: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
        706: {
            slidesPerView: 2,
          },
          320: {
            dragSize: 20,
            slidesPerView: 1.2,
            
          }
        }
      });
    }
      } else {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
      }
    };
    
    handleSwiper();
    window.addEventListener('resize', handleSwiper);
